import { defineComponent as n, useAttrs as a, computed as l, openBlock as c, createElementBlock as p, mergeProps as u, unref as i } from "vue";
import { getSpinnerStyleClasses as m } from "./novoui-vuejs43.js";
const S = /* @__PURE__ */ n({
  __name: "NSpinner",
  props: {
    color: { default: "blue" },
    size: { default: "medium" },
    absolute: { type: Boolean, default: !1 }
  },
  setup(s) {
    const e = s, { class: t, ...o } = a(), r = l(() => m(e.color, e.size, e.absolute));
    return (f, d) => (c(), p("span", u({
      class: [r.value, i(t)]
    }, o), "Loading...", 16));
  }
});
export {
  S as default
};
